import React from 'react'
import AuthHeaderDynamicMenu from './AuthHeaderDynamicMenu'
import AuthHeaderUserMenu from './AuthHeaderUserMenu'

function AuthHeaderLogged({ tabIndex }) {
  return (
    <div className="_d-flex" data-testid="header-logged">
      <AuthHeaderDynamicMenu tabIndex={tabIndex} />
      <AuthHeaderUserMenu tabIndex={tabIndex} />
    </div>
  )
}

export default AuthHeaderLogged
